import { Outlet, ScrollRestoration } from "react-router";
import { Box, Container } from "@mui/material";
import { Footer } from "./Footer";
import { Header } from "./Header";

export const Layout = () => (
  <>
    <ScrollRestoration />
    <Box
      sx={{
        minHeight: "100%",
        display: "grid",
        gridTemplateRows: "1fr auto auto",
        gridTemplateColumns: "100%",
      }}
    >
      <Header />
      <Container
        component="main"
        maxWidth="xl"
        sx={{ marginTop: "70px", pt: 5, position: "relative" }}
      >
        <Outlet />
      </Container>
      <Footer />
    </Box>
  </>
);
